import { Box } from '@mui/material';
import { ReactNode } from 'react';

type LevelThreeGridProps = {
    maxWidth: number;
    rows: number;
    rowGap: number;
    columnWidth: number;
    children: ReactNode;
};

export function LevelThreeGrid(props:LevelThreeGridProps) {
    const { children, rowGap, maxWidth, rows, columnWidth } = props;

    return (
        <Box
            sx={{
                padding: 4,
                maxWidth,
                flexGrow: 1,
                display: 'grid',
                rowGap,
                gridAutoFlow: 'column',
                gridTemplateRows: `repeat(${rows}, 1fr)`,
                gridTemplateColumns: `repeat(auto-fill, ${columnWidth}px)`,
                alignContent: 'flex-start',
                maxHeight: 300,
            }}
        >
            {children}
        </Box>
    );
}
